module.exports = __webpack_public_path__ + "img/biaozhun-xiaopiao.2ca32728.svg";